import React from "react";
import { FiCode, FiGlobe, FiCloud } from "react-icons/fi";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
  {
    icon: <FiCode />,
    title: "Software Development",
    description:
      "Our software development services provide tailored solutions to address the unique needs of businesses, driving growth and efficiency through innovative and cutting-edge technology.",
  },
  {
    icon: <FiGlobe />,
    title: "Software as a Service (SaaS)",
    description:
      "Our Software as a Service (SaaS) solutions offer businesses flexible and cost-effective access to innovative technology, providing a competitive edge and driving growth and success.",
  },
  {
    icon: <FiCloud />,
    title: "Cloud Computing",
    description:
      "Our cloud computing solutions enable businesses to access flexible and scalable IT resources, reducing costs and enhancing efficiency while empowering digital transformation.",
  },
];

const ServiceOne = ({ textAlign, serviceStyle }) => {
  return (
    <div className="row row--15 service-wrapper">
      {ServiceList.map((val, i) => (
        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
          <ScrollAnimation
            animateIn="fadeInUp"
            animateOut="fadeInOut"
            animateOnce={true}
          >
            <div className={`service ${serviceStyle} ${textAlign}`}>
              <div className="icon">{val.icon}</div>
              <div className="content">
                <h4 className="title w-600">
                  <Link
                    to="#service"
                    dangerouslySetInnerHTML={{ __html: val.title }}
                  ></Link>
                </h4>
                <p
                  className="description b1 color-gray mb--0"
                  dangerouslySetInnerHTML={{ __html: val.description }}
                ></p>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      ))}
    </div>
  );
};
export default ServiceOne;
